import { render, staticRenderFns } from "./simcardmanagement.vue?vue&type=template&id=6388c4a8&scoped=true"
import script from "./simcardmanagement.vue?vue&type=script&lang=js"
export * from "./simcardmanagement.vue?vue&type=script&lang=js"
import style0 from "./simcardmanagement.vue?vue&type=style&index=0&id=6388c4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388c4a8",
  null
  
)

export default component.exports